
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/dice",
      function () {
        return require("private-next-pages/casino/dice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/dice"])
      });
    }
  